import { TitleWithInfo } from "app/components/TitleWithInfo/TitleWithInfo";
import { translate } from "app/filters/i18nFilter";

import { StyledHeaderContainer } from "./styles";

type HeaderSchema = {
    tooltip: string;
};

export const Header = ({ tooltip }: HeaderSchema) => {
    return (
        <StyledHeaderContainer>
            <TitleWithInfo
                title={translate("bt.metrics.monthlyVisits.myShare.title")}
                tooltip={translate(tooltip)}
            />
        </StyledHeaderContainer>
    );
};
